module.exports = __webpack_public_path__ + "static/media/icon-check-circle-active.ab1ec598.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-check-circle-active.svg
// module id = 1845
// module chunks = 0